import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const FavoriteIcon = ({ width = 24, height = 24, color = colors.grey[50] }: IProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 24 24' fill='none'>
            <path
                d='M6.54492 1C2.92992 1 0 3.92992 0 7.54492C0 13.8373 7.29898 19.8498 10.709 22.5273C10.7122 22.53 10.7155 22.5326 10.7188 22.5352C10.7421 22.5535 10.7739 22.5796 10.7969 22.5977L10.7988 22.5957C11.1448 22.8571 11.5664 22.999 12 23C12.4343 22.9994 12.8566 22.8575 13.2031 22.5957V22.5977C13.2099 22.5924 13.2198 22.5854 13.2266 22.5801C13.2317 22.576 13.239 22.5705 13.2441 22.5664C13.2507 22.5606 13.2572 22.5547 13.2637 22.5488C16.6631 19.8809 24 13.8523 24 7.54492C24 3.92992 21.0701 1 17.4551 1C14.0001 1 12 4 12 4C12 4 9.99992 1 6.54492 1Z'
                fill={color}
            />
        </svg>
    )
}

export default React.memo(FavoriteIcon)
